import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import About from "../Components/AboutMain/About";

function AboutUs() {
  return (
    <>
      <Navbar />
      <About />
      <Footer />
    </>
  );
}

export default AboutUs;
